import styled, {css} from 'styled-components'
import {StyledTableBodyCell} from '@/components/ui/table-atoms/style'

export const StyledWrapper = styled.div(
    ({theme: {palette, spacing}}) => css`
        display: grid;
        grid-template-rows: auto auto minmax(0, 1fr);
        background-color: ${palette.neutral.white};
        height: 100%;
        border-radius: 0 0 8px 8px;
        border: 1px solid ${palette.neutral[200]};
        border-top: none;

        ${StyledTableBodyCell} {
            height: auto;
            min-height: ${spacing * 16}px;
        }
    `
)

export const StyledExportNameCell = styled.div(
    ({theme: {spacing, typography, palette}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 0.5}px;

        & > strong {
            ${typography.textSm};
            font-weight: 500;
            color: ${palette.neutral[900]};
        }

        & > span {
            ${typography.textXs};
            color: ${palette.neutral[600]};
        }
    `
)

export const StyledExportNameSubtitleRow = styled.div(
    ({theme: {spacing, typography}}) => css`
        ${typography.textMd}
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
    `
)

export const StyledExportNameTitleRow = styled.div(
    ({theme: {typography, spacing, palette}}) => css`
        ${typography.textSm}
        display: flex;
        gap: ${spacing * 2}px;
        color: ${palette.neutral['500']};
    `
)

export const StyledCreatedAtCell = styled.div(
    ({theme: {spacing, typography, palette}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 0.5}px;

        & > strong {
            ${typography.textSm};
            font-weight: 400;
            color: ${palette.neutral[900]};
        }

        & > span {
            ${typography.textXs};
            color: ${palette.neutral[600]};
        }
    `
)
